import { ArrowUpRight } from "lucide-react";
import { Mapa3D } from "./Mapa3D";

const INFO = {
  inmuebles: ["Cargá informes de dominio y analizá cada inmueble", "Informes · satélite · PDF"],
  clientes: ["Patrimonio inmobiliario de cada cliente", "Fichas · vínculos"],
  titulares: ["Buscá propietarios por nombre, CI o RUC", "Índice catastral"],
  vigilancia: ["Seguimiento de tu cartera de garantías", "Alertas · cambios"],
  escribano: ["Situación registral del inmueble para pedir al Registro", "RUM · dominio · gravámenes"],
  barrido: ["Barrido catastral continuo del país", "SNC · progreso"],
  novedades: ["Cambios de titular y gravámenes en todo el índice", "Avisos · 6 días"],
  salud: ["Estado de los servicios y fuentes", "Monitoreo"],
  admin: ["Usuarios, empresas y tablas", "Administración"],
};
const AREAS = ["a", "b", "c", "d", "e", "f", "g", "h"];

export { Mapa3D };

const Tarjeta = ({ id, label, area, i, onIr }) => <button onClick={() => onIr(id)} className="ins-card" style={{ gridArea: area, "--d": `${i * 0.06}s` }} data-testid={`inicio-seccion-${id}`}>
  <img src={`${process.env.PUBLIC_URL || ""}/secciones/${id}.webp?v=3`} alt="" loading="lazy" className="ins-card-img" />
  <span className="ins-card-sombra" />
  <span className="ins-card-tag">{INFO[id]?.[1]}</span>
  <span className="ins-card-pie">
    <span><b className="ins-card-tit">{label}</b><span className="ins-card-sub">{INFO[id]?.[0]}</span></span>
    <ArrowUpRight className="ins-card-flecha" />
  </span>
</button>;

export default function InicioSecciones({ tabs, nombre, onIr }) {
  return <section className="ins-root" data-testid="inicio-secciones">
    <div className="ins-cab">
      <p className="ins-ojo">TierraScore · Secciones</p>
      <h1 className="ins-h1">Hola{nombre ? `, ${nombre.split(" ")[0]}` : ""}. ¿Por dónde empezamos?</h1>
    </div>
    <div className={`ins-grid ins-n${Math.min(tabs.length, 8)}`}>
      <div className="ins-centro" style={{ gridArea: "m" }}><Mapa3D /></div>
      {tabs.slice(0, 8).map(([id, l], i) => <Tarjeta key={id} id={id} label={l} area={AREAS[i]} i={i} onIr={onIr} />)}
    </div>
  </section>;
}
